import http from "./http-common";

const getMarketPrices = (payload) => {
  return http.get("https://api.coingecko.com/api/v3/coins/markets", { params: payload });
};

const CampaignService = {
  getMarketPrices,
};
export default CampaignService;